export default __webpack_public_path__ + "static/media/image-36.252876b8.png";